import * as React from "react";
import PropTypes from 'prop-types';

const SvgIconsChevronUp = props => {
  if (props.id !== "_svgiconschevronup") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 33 32" fill="none" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M24.939 20.874a1.196 1.196 0 001.69-1.69l-9.226-9.227a1.19 1.19 0 00-.532-.309c-.44-.13-.97.004-1.355.388l-8.988 8.988c-.532.533-.585 1.345-.117 1.813.469.468 1.28.416 1.813-.117l8.28-8.28 8.435 8.434z" fill="#202020" /></svg>;
};

SvgIconsChevronUp.displayName = "_svgiconschevronup";
SvgIconsChevronUp.propTypes = {
  id: PropTypes.string
};
SvgIconsChevronUp.defaultProps = {
  id: ''
};
export default SvgIconsChevronUp;